import React from "react";
import { type IFiltroClientesVistaProps } from "../interfaces";
import {
    TextInput,
    Grid,
    Box,
    Text,
    Button,
} from "@mantine/core";
import { IconSearch } from "@tabler/icons-react";

const FiltroClientesVista: React.FunctionComponent<IFiltroClientesVistaProps> = ({
    consultarClientes,
    filtro,
    manejarCambioFiltroCliente
}) => {

    return (
        <Box pl="md" pr="md" pb="sm" pt="sm">
            <Grid gutter="sm" >
                <Grid.Col span={{ base: 12, md: 3 }}>
                    <TextInput
                        // label="Identificación Cliente"
                        placeholder="Identificación Cliente"
                        name="IdentificacionCliente"
                        size="xs"
                        maxLength={50}
                        value={filtro.Identificacion || ""}
                        onChange={(event) => {
                            manejarCambioFiltroCliente("Identificacion", event.currentTarget.value)
                        }}
                    />
                </Grid.Col>
                <Grid.Col
                    span={{ base: 12, md: 3 }}
                    style={{ display: "flex", alignItems: "flex-end" }}
                >
                    <Button
                        onClick={consultarClientes}
                        color="primary"
                        variant="filled"
                        size="compact-sm"
                        radius="lg"
                        rightSection={<IconSearch opacity={1} size={12} />}
                    >
                        <Text fw={500} fz={11}>
                            Consultar
                        </Text>
                    </Button>
                </Grid.Col>

            </Grid>
        </Box>

    );
}

export default FiltroClientesVista;